import React from "react";
import styled from "styled-components";

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  grid-column-gap: 20px;

  @media (max-width: ${(props) => props.theme.smBreakpoint}) {
    grid-template-columns: 1fr;
  }
`;

function SprintHeaderContainer(props) {
  /** Reusable header container component to be used in sprint headers. */
  return <HeaderContainer>{props.children}</HeaderContainer>;
}

export default SprintHeaderContainer;
